export enum GlobalMenuGroupsRoutePathNames {
  BRANDS = 'brands',
  GLOBAL_MENU_GROUPS = 'global-menus',
  BRAND_DETAILS = 'brand',
  LIST = '',
  ID = ':id',
  BRAND_ID = ':brandId',
  MENUS = 'menus',
  MENU_ID = ':menuId',
  CATEGORY = 'category',
  CATEGORY_ID = ':categoryId',
  ITEMS = 'items',
  MOD_GROUP = 'modifier-group',
  MOD_GROUP_ID = ':modifierGroupId?',
  MODIFIERS = 'modifiers',
  ENTITY = ':entity',
  ENTITY_ID = ':entityId?',
  MODE = ':mode?',
  ACTIVE_BRANDS = 'active-brands',
  ARCHIVED_BRANDS = 'archived-brands',
  MANAGEMENT = 'management',
  ACTIVITY_LOG = 'activity-log',
  MENUWORKS = 'menuworks',
  MENUWORKS_UNIT_ID = ':unitId?',
}
